import { defaultHeights } from 'components/Theme'
import { IUser } from 'features/auth/types'
import { useEffect, useState } from 'react'

/**
 * Window dimension to get the current page size
 * @returns
 */
function getWindowDimensions() {
  const { innerWidth: windowWidth, innerHeight: windowHeight } = window
  return {
    windowWidth,
    windowHeight,
  }
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions())

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowDimensions
}

/** //TODO: Based on your need please write your condition
 *
 * @param isNav is true then nav bar will be considered for the inner div height
 * @param isBreadcrumb is true then nav bar will be considered for the inner div height
 * @param isFooter is true then nav bar will be considered for the inner div height
 */
export function getCurrentWindowInnerHeight(isNav = true, isBreadcrumb = true, isFooter = true): number {
  if (isNav && isBreadcrumb && isFooter) {
    const navBarHeight = defaultHeights.navbarHeight
    const breadCrumbHeight = defaultHeights.breadcrumbHeight
    const { windowHeight } = useWindowDimensions()

    const currentInnerWindowHeight = windowHeight - (navBarHeight + breadCrumbHeight)
    return currentInnerWindowHeight
  } else {
    return useWindowDimensions().windowHeight
  }
}

export function isOutboundUser(user: IUser) {
  return user?.email.endsWith('@outbound.ai') ? true : false
}

function pad(n: number, width = 2): string {
  return String(n).padStart(width, '0')
}
export function localIsoToUtcIso(localIsoStr: string): string {
  const localDate = new Date(localIsoStr)
  return localDate.toISOString()
}

export function utcIsoToLocalIso(utcIsoStr: string): string {
  const date = new Date(utcIsoStr)

  const year = date.getFullYear()
  const month = pad(date.getMonth() + 1)
  const day = pad(date.getDate())
  const hours = pad(date.getHours())
  const minutes = pad(date.getMinutes())
  const seconds = pad(date.getSeconds())
  const millis = pad(date.getMilliseconds(), 3)

  const totalOffsetMinutes = -date.getTimezoneOffset()
  const sign = totalOffsetMinutes >= 0 ? '+' : '-'
  const absOffset = Math.abs(totalOffsetMinutes)
  const offsetHrs = pad(Math.floor(absOffset / 60))
  const offsetMins = pad(absOffset % 60)

  return `${year}-${month}-${day}T` + `${hours}:${minutes}:${seconds}.${millis}` + `${sign}${offsetHrs}:${offsetMins}`
}
